module.exports = __webpack_public_path__ + "760e083d4dbd410f6272c3eb43ee16cf.MP3";